<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">Основной ОКВЕД</div>
            <div class="dx-field-value">
                <ai-text-box-dictionary :value="data.kod_okved" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';
import AiTextBoxDictionary from '@/components/ai-text-box-dictionary.vue';

const data = inject('serverData');
</script>
